import './init'
import '@fortawesome/fontawesome-free/css/all.min.css'
import 'animate.css'
import '@modules/admin/analytics/analytics.scss'
import Processing from '@modules/core/components/Loading'

import 'rc-slider/assets/index.css'
import { Suspense } from 'react'

import 'react-datepicker/dist/react-datepicker.css'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import 'react-select-legacy/scss/default.scss'
import 'react-select-legacy/scss/select.scss'
import { persistStore } from 'redux-persist'
import { PersistGate } from 'redux-persist/integration/react'
import store from '@services/Store'
import App from './modules/App'
import './resources/assets/css/icon-medipremium.css'
import './resources/assets/css/main.css'
import './resources/assets/img/favicon.ico'
import './resources/assets/img/high.png'
import './resources/assets/sass/app.scss'
import initializeI18n from './Services/i18n'

initializeI18n()

ReactDOM.render(
  <Provider store={store}>
    <PersistGate loading={<Processing isFetching={true} />} persistor={persistStore(store)}>
      <Suspense fallback="loading">
        <App />
      </Suspense>
    </PersistGate>
  </Provider>,
  document.getElementById('root')
)
